import { Clock, Gift } from "lucide-react";
import { CREDIT_PACKAGES } from "@/config/packages";
import { getNewUserOfferBonus } from "@/config/new-user-offer";

interface NewUserOfferStripProps {
  isActive: boolean;
  countdownLabel: string;
}

/** Compact offer block for tight surfaces like the out-of-credits modal. */
export function NewUserOfferStrip({ isActive, countdownLabel }: NewUserOfferStripProps) {
  if (!isActive) return null;

  return (
    <div className="mx-5 mb-4 rounded-2xl border-2 border-emerald-400 bg-emerald-50/90 overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-3.5 py-2.5 border-b-2 border-emerald-200/60 bg-emerald-500/10">
        <div className="flex items-center gap-2 min-w-0">
          <Gift className="size-4 text-emerald-600 shrink-0" />
          <p className="text-[11px] font-extrabold text-emerald-800 leading-tight">
            Limited welcome offer — extra bonus tokens
          </p>
        </div>
        <div className="flex items-center gap-1.5 shrink-0 rounded-lg bg-white border-2 border-emerald-200/80 px-2.5 py-1">
          <Clock className="size-3.5 text-emerald-600" />
          <span className="text-[15px] font-black tabular-nums text-emerald-800 leading-none">
            {countdownLabel}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-3 divide-x-2 divide-emerald-200/60">
        {CREDIT_PACKAGES.map((pkg) => {
          const bonus = getNewUserOfferBonus(pkg.id);
          if (!bonus) return null;
          const base = pkg.credits - bonus;
          return (
            <div key={pkg.id} className="px-2 py-2.5 text-center">
              <p className="text-[9px] font-extrabold uppercase tracking-wide text-emerald-700/80 mb-0.5">
                {pkg.name}
              </p>
              <p className="text-[11px] font-bold text-[#241d3a]/70 tabular-nums leading-none">
                {base}
              </p>
              <p className="text-[16px] font-black text-emerald-600 tabular-nums leading-tight mt-0.5">
                +{bonus}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
